export function getFileExtension(file: File): string | null {
    const lastDotIndex = file.name.lastIndexOf(".");
    if (lastDotIndex <= 0) {
        return null;
    }

    const extension = file.name.slice(lastDotIndex + 1);
    return extension ? extension.toLowerCase() : null;
}
